"use client";
import React from 'react';
import { motion } from 'framer-motion';

export default function GeometricPattern({
  color = '#C9A84C',
  opacity = 0.06,
  size = 120,
  animate = true,
}) {
  const s = size;
  const half = s / 2;
  const r = s * 0.38;
  const cornerR = r * 0.42;
  const starPoints = Array.from({ length: 16 }, (_, i) => {
    const angle = (i * Math.PI) / 8 - Math.PI / 2;
    const rad = i % 2 === 0 ? r : r * 0.42;
    return `${half + rad * Math.cos(angle)},${half + rad * Math.sin(angle)}`;
  }).join(' ');

  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
      <svg style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity }}>
        <defs>
          <pattern id={`islamic-geo-${size}-${color.replace('#','')}`} x="0" y="0" width={s} height={s} patternUnits="userSpaceOnUse">
            <polygon points={starPoints} fill="none" stroke={color} strokeWidth="0.8" />
            <rect x={half - cornerR} y={half - cornerR} width={cornerR * 2} height={cornerR * 2} fill="none" stroke={color} strokeWidth="0.5" transform={`rotate(45 ${half} ${half})`} />
            <line x1="0" y1={half} x2={half - r} y2={half} stroke={color} strokeWidth="0.4" />
            <line x1={half + r} y1={half} x2={s} y2={half} stroke={color} strokeWidth="0.4" />
            <line x1={half} y1="0" x2={half} y2={half - r} stroke={color} strokeWidth="0.4" />
            <line x1={half} y1={half + r} x2={half} y2={s} stroke={color} strokeWidth="0.4" />
          </pattern>
        </defs>
        <motion.rect
          width="100%"
          height="100%"
          fill={`url(#islamic-geo-${size}-${color.replace('#','')})`}
          initial={animate ? { opacity: 0 } : false}
          animate={animate ? { opacity: 1 } : false}
          transition={{ duration: 1.5, delay: 0.3 }}
        />
      </svg>
    </div>
  );
}
